import * as actions from './constants';

const initialState = {
  currentUser: null,
  loggedInAs: '',
  isLogin: false,
  loading: true
};

// eslint-disable-next-line default-param-last
export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case actions.USER_LOGIN:
      return {
        ...state,
        currentUser: action.response.currentUser,
        isLogin: action.response.isLogin,
        loading: action.response.loading,
        loggedInAs: action.response.currentUser?.profile ?? ''
      };
    case actions.UPDATE_USER:
      return {
        ...state,
        currentUser: action.payload,
        loggedInAs: action.payload?.profile ?? ''
      };
    case actions.USER_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case actions.REMOVE_USER:
      return {
        currentUser: null,
        isLogin: false,
        loggedInAs: ''
      };
    default:
      return state;
  }
}
